/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/TextField/theme';

export const TextFieldTheme = theme;
